import axios from "axios";
import { API } from "../utils/apiURL";

export const getAll = async ( code, page) => {
//   let apiUrl = `${API}/sales/me?page=${data}`;
//   if (status) apiUrl += `&status=${status}`;

  const res = await axios.get(`${API}/news?code=${code}&page=${page}`);
  return res.data;
};